import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';

import { AnalyticsTabConfig, AnalyticsTabId } from '../constants/analyticsTabs';

type AnalyticsTabsProps = {
  tabs: AnalyticsTabConfig[];
  activeTabId: AnalyticsTabId;
  // eslint-disable-next-line no-unused-vars
  onSelect: (id: AnalyticsTabId) => void;
};

const AnalyticsTabs: FC<AnalyticsTabsProps> = ({
  tabs,
  activeTabId,
  onSelect,
}) => {
  const { t } = useTranslate();

  return (
    <ul className="nav nav-tabs nav-tabs-mb-icon nav-tabs-card mb-3">
      {tabs.map((tab) => (
        <li className="nav-item" key={tab.id}>
          <button
            type="button"
            data-testid={`analytics-tab-${tab.id}`}
            className={`nav-link ${activeTabId === tab.id ? 'active' : ''}`}
            onClick={() => onSelect(tab.id)}
          >
            <em className={`icon ni ${tab.icon}`} />
            <span>{t(tab.labelKey)}</span>
          </button>
        </li>
      ))}
    </ul>
  );
};

export default AnalyticsTabs;
